import { all } from 'redux-saga/effects';
import companyInfoServiceWorker from './campanyInfoSaga';
import getCompanyInfoServiceWorker from './campanyInfoSaga';

export default function* rootSaga(action) {
	yield all([companyInfoServiceWorker(action)]);
	yield all([getCompanyInfoServiceWorker(action)]);
}
